import { Button, Divider, Form, Input, Modal, notification } from '@pankod/refine-antd';
import { useState } from 'react';
import { createOrganization } from 'services/organization';
import useOrganizationStore from 'store/useOrganizationStore';

interface OrgCreateModalProps {
  isModalOpen: boolean;
  closeModal: () => void;
}

export const OrgCreateModal: React.FC<OrgCreateModalProps> = ({ isModalOpen, closeModal }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { addOrganization } = useOrganizationStore();
  const [form] = Form.useForm();

  const onFinish = async (values: any) => {
    // Reset name error
    form.setFields([{ name: 'name', errors: [] }]);

    // Validation for name input
    const regex = /(?<!\w)(?!org)^[a-zA-Z0-9][a-zA-Z0-9 ]*[a-zA-Z0-9]+$/i;
    if (!regex.test(values.name)) {
      form.setFields([
        {
          name: 'name',
          errors: [`Name must contain only letters or numbers, and must not start with 'org'`],
        },
      ]);
      return;
    }

    setIsLoading(true);
    try {
      const data = {
        name: values.name,
        phone: values.phone,
        contact: values.contact,
        address: values.address,
      };
      const response = await createOrganization(data);
      addOrganization({ ...response });
      form.resetFields();
    } catch (err: any) {
      console.error(err);
      notification.error({
        message: 'Failed',
        description: err.message,
      });
    }
    setIsLoading(false);
    closeModal();
  };

  return (
    <Modal
      title="Create Organization"
      footer={null}
      visible={isModalOpen}
      onOk={closeModal}
      onCancel={closeModal}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          label="Name"
          name="name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input showCount maxLength={30} placeholder="Organization name" />
        </Form.Item>
        <Form.Item
          label="Phone"
          name="phone"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input placeholder="Your organization phone number" />
        </Form.Item>
        <Form.Item
          label="Contact"
          name="contact"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input placeholder="Your organization contact info" />
        </Form.Item>
        <Form.Item
          label="Address"
          name="address"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input placeholder="Organization address" />
        </Form.Item>

        <Divider />

        <Form.Item wrapperCol={{ offset: 15, span: 24 }}>
          <Button onClick={closeModal} htmlType="button">
            Cancel
          </Button>
          <Button
            loading={isLoading}
            type="primary"
            htmlType="submit"
            style={{ marginLeft: '10px' }}
          >
            Create
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};
